function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExtensionProps(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M20,22.2V20.76H19a3.25,3.25,0,0,0-.35-.84l.74-.73-1-1-.74.75a2.66,2.66,0,0,0-.85-.36v-1H15.31v1a2.66,2.66,0,0,0-.85.36l-.76-.75-1,1,.74.73a2.94,2.94,0,0,0-.35.84h-1v1.44h1.1a3.94,3.94,0,0,0,.35.88l-.77.71.94,1.08.75-.74a3.2,3.2,0,0,0,.85.36v1h1.45V24.43a2.88,2.88,0,0,0,.85-.35l.73.75,1.05-1-.75-.7a3.84,3.84,0,0,0,.36-.8ZM16,23a1.46,1.46,0,1,1,1.45-1.47h0A1.47,1.47,0,0,1,16,23Z",
    style: {
      fill: "#9868b9"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M26.5,12.59C26.49,10.78,25.24,9.2,23,8a15.57,15.57,0,0,0-7-1.49A15.38,15.38,0,0,0,9,8C6.76,9.15,5.53,10.83,5.5,12.66h0l.06,1.26a1.06,1.06,0,0,0,1,1l4.15,0a1.06,1.06,0,0,0,1-1l0-1.26c0-.57,1-2.24,4.22-2.23s4.26,1.54,4.24,2.19l-.06,1.28a1,1,0,0,0,1,1l4.08.05a1,1,0,0,0,1-1C26.49,13.91,26.5,12.59,26.5,12.59Z",
    style: {
      fill: "#7e7e7e"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExtensionProps);
export default __webpack_public_path__ + "static/media/extension-props.5f7dd044.svg";
export { ForwardRef as ReactComponent };